import React from "react";
import { Box, Typography, useTheme } from "@material-ui/core";
import { formatLabelBgColor, formatLabelTextColor } from "styles/colors";

interface CardSubheaderProps {
    label: string;
    format?: string;
}

// TODO: Add memo
export const CardSubheader = ({ label, format }: CardSubheaderProps) => {
    const theme = useTheme();

    return (
        <Box display="flex" alignItems="center">
            <Typography component="div" variant="subtitle2" color="textSecondary">
                <Box pr={0.5}>{label}</Box>
            </Typography>
            {format && (
                <Typography component="div" variant="subtitle2" color="textSecondary">
                    <Box
                        px={`${theme.spacing(0.5)}px`}
                        minWidth={theme.spacing(4)}
                        borderRadius={`${theme.spacing(0.5)}px`}
                        fontWeight="fontWeightBold"
                        fontSize={`${theme.spacing(1.25)}px`}
                        color={formatLabelTextColor}
                        textAlign="center"
                        bgcolor={formatLabelBgColor}>
                        {format.toUpperCase()}
                    </Box>
                </Typography>
            )}
        </Box>
    );
};
